"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailDistrictInfoState = void 0;
var DistrictState_init_1 = require("@/pages/place/states/DistrictState.init");
exports.defaultDetailDistrictInfoState = {
    id: 89,
    name: 'Discovery Bay',
    image: DistrictState_init_1.defaultDistrictState.galleryItems[0].src,
};
